import { Flag } from '@mui/icons-material';
import { Box, Fab } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Socket } from 'socket.io-client';
import './styles.css';

type PropTypes = {
  profileId: string;
  questionIndex: number;
  gameId: string;
  socket: Socket;
};

export const ReportInaccuracyButton = ({
  profileId,
  questionIndex,
  gameId,
  socket,
}: PropTypes) => {
  const [isReported, setIsReported] = useState(false);

  useEffect(() => {
    setIsReported(false);
  }, [questionIndex]);

  const handleClick = () => {
    setIsReported(true);
    socket.emit('reportInaccuracy', {
      gameId,
      questionIndex,
      profileId: profileId,
    });
  };

  return (
    <Fab
      variant="extended"
      color="secondary"
      size="small"
      sx={{ float: 'right', margin: '8px' }}
      disabled={isReported}
      onClick={handleClick}
    >
      <Flag sx={{ mr: { xs: 0, md: 1 } }} />
      <Box
        component="span"
        sx={{
          display: { xs: 'none', md: 'inherit' },
        }}
      >
        {isReported ? 'Thank you for reporting' : 'Report inaccuracy'}
      </Box>
    </Fab>
  );
};
